"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
var react_mapbox_gl_1 = __importDefault(require("react-mapbox-gl"));
var react_1 = __importStar(require("react"));
var react_mapbox_gl_2 = require("react-mapbox-gl");
var text_field_1 = require("../../ui/text-field");
var index_css_1 = __importDefault(require("./index.css"));
var react_mapbox_gl_3 = require("react-mapbox-gl");
var marker_png_1 = __importDefault(require("../../static/images/marker.png"));
var texts_1 = require("../../ui/texts");
var MAPBOX_TOKEN = "pk.eyJ1IjoicmFmYWx5bmNoIiwiYSI6ImNrd2k0cnk4aDE0eTgybm5vNTl5bTd5M2kifQ.4UXWIHJo4uN2YpRTqoTCYw";
var Mapbox = (0, react_mapbox_gl_1.default)({
    accessToken: MAPBOX_TOKEN,
});
function Map(props) {
    var initialCoords = props.defaultCoords || [-0, 0];
    var _a = (0, react_1.useState)(initialCoords), coords = _a[0], setCoords = _a[1];
    var _b = (0, react_1.useState)(""), query = _b[0], setQuery = _b[1];
    var _c = (0, react_1.useState)(props.defaultCoords || false), showMarker = _c[0], setShowMarker = _c[1];
    (0, react_1.useEffect)(function () {
        if (!props.defaultCoords) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setCoords([position.coords.longitude, position.coords.latitude]);
            });
        }
    }, []);
    function handleChange(e) {
        setQuery(e.target.value);
    }
    function keydownInputHandler(e) {
        if (e.key == "Enter") {
            search(query);
        }
    }
    function search(query) {
        fetch("https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(query, ".json?access_token=").concat(MAPBOX_TOKEN, "&country=AR&limit=1")).then(function (res) {
            return res.json().then(function (data) {
                var locationData = {
                    lng: data.features[0].geometry.coordinates[0],
                    lat: data.features[0].geometry.coordinates[1],
                    city: data.features[0].text,
                    region: data.features[0].context[0].text,
                };
                handleSearchResults(locationData);
            });
        });
    }
    function handleSearchResults(locationData) {
        setCoords([locationData.lng, locationData.lat]);
        setShowMarker(true);
        props.cb(locationData);
    }
    return (react_1.default.createElement("div", { className: index_css_1.default.container },
        react_1.default.createElement(Mapbox, { style: "mapbox://styles/mapbox/streets-v11", containerStyle: {
                height: "300px",
                width: "335px",
            }, center: coords, zoom: [15] },
            react_1.default.createElement(react_mapbox_gl_2.Layer, { type: "symbol", id: "marker", layout: { "icon-image": "marker-15" } },
                react_1.default.createElement(react_mapbox_gl_2.Feature, { coordinates: coords })),
            showMarker && (react_1.default.createElement(react_mapbox_gl_3.Marker, { coordinates: coords, anchor: "bottom" },
                react_1.default.createElement("img", { src: marker_png_1.default, className: index_css_1.default["marker-img"] })))),
        react_1.default.createElement(text_field_1.TextField, { autoComplete: "off", onKeyDown: keydownInputHandler, onChange: handleChange, label: "UBICACION", name: "ubicacion", type: "text" }),
        react_1.default.createElement("span", { className: index_css_1.default.instructions },
            react_1.default.createElement(texts_1.CustomLongText, null, "Busc\u00E1 un punto de referencia para reportar a tu mascota. Puede ser una direcci\u00F3n, un barrio o una ciudad."))));
}
exports.Map = Map;
